































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import PageTitle from '@/app/components/Common/PageTitle.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import DeleteModal from '@/app/components/Common/DeleteModal.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import ConfirmModal from '@/app/components/Common/ConfirmModal.vue'
/* api */
import VarietyListApi from '@/app/model/api/varietyListApi'
import VarietyDetailApi from '@/app/model/api/varietyDetailApi'
import AreaListApi from '@/app/model/api/areaListApi'
import VarietyGrowthDetailApi from '@/app/model/api/varietyGrowthDetailApi'
import VarietyGrowthCreateApi from '@/app/model/api/varietyGrowthCreateApi'
import VarietyGrowthEditApi from '@/app/model/api/varietyGrowthEditApi'
import VarietyGrowthDeleteApi from '@/app/model/api/varietyGrowthDeleteApi'
/* module */
import CommonClass from '@/app/module/common'
import Validator from '@/app/module/validator'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'

@Component({
  components: {
    CommonHeader,
    PageTitle,
    ErrorModal,
    DeleteModal,
    Error409Modal,
    Loading,
    ConfirmModal,
    ErrorInfo
  }
})
export default class GroupCreate extends Vue {
  private intermittentWaterPeriodFlags: any = []
  private checkList: any = []
  private beforeCheckList: any = []
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  private varietyData: any = []
  private areaData: any = []
  private constantValue: any = []
  private isError: any = {}
  private isDisable: any = {}
  private varietyDetail: any = []
  private varietyGrowthData: any = {
    variety_growth: {
      variety_growth_name: '',
      variety_id: '',
      area_id: '',
      cultivation_method_id: 1,
      harvest_correction_minus: 3,
      harvest_correction_plus: 3,
      sowing_period_from: null,
      sowing_period_to: null,
      season_id: 1,
      remarks: '',
      ref_ear: null,
      ref_grain: null,
      ref_thousand_grains_weight: null,
      ref_ripe_rate: null,
      ref_yield: null,
      completion_status: 2,
      variety_growth_checklist: []
    },
    variety_growth_stages: [
      {
        step: 1,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '播種潅水',
        water_level: 5,
        water_control_days: 7,
        intermittent_water_period_flag: 0
      },
      {
        step: 3,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '移植深水',
        water_level: 10,
        water_control_days: 14,
        intermittent_water_period_flag: 0
      },
      {
        step: 4,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: 'ぶんけつ浅水',
        water_level: 5,
        water_control_days: 25,
        intermittent_water_period_flag: 0
      },
      {
        step: 5,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '中干し',
        water_level: 0,
        water_control_days: 7,
        intermittent_water_period_flag: 0
      },
      {
        step: 6,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '深水',
        water_level: 10,
        water_control_days: 8,
        intermittent_water_period_flag: 0
      },
      {
        step: 7,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '間断潅水',
        water_level: 10,
        water_control_days: 20,
        intermittent_water_period_flag: 0
      },
      {
        step: 8,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '間断潅水',
        water_level: 10,
        water_control_days: 16,
        intermittent_water_period_flag: 0
      },
      {
        step: 9,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '湛水',
        water_level: 6,
        water_control_days: 20,
        intermittent_water_period_flag: 0
      },
      {
        step: 10,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '間断潅水',
        water_level: 5,
        water_control_days: 16,
        intermittent_water_period_flag: 0
      },
      {
        step: 11,
        integrated_temp: 0,
        spad: 0,
        stem_number: null,
        stem_number_m2: null,
        growth_height: 0,
        ph: 0,
        water_temp: 0,
        ground_temp: 0,
        water_control_name: '水切り',
        water_level: 0,
        water_control_days: 0,
        intermittent_water_period_flag: 0
      }
    ]
  }
  private completionStatus: any = [
    { text: '完成版', value: 1 },
    { text: '暫定版', value: 2 },
    { text: '情報未入手', value: 3 }
  ]
  private masterKeys: any = [
    {
      keyName: 'spad',
      parameta: '葉色値',
      errorName: 'spadErrorMessage'
    },
    {
      keyName: 'stem_number',
      parameta: '茎数(本/株)',
      errorName: 'stemNumberErrorMessage'
    },
    {
      keyName: 'stem_number_m2',
      parameta: '茎数(本/平米)',
      errorName: 'stemNumberM2ErrorMessage'
    },
    {
      keyName: 'growth_height',
      parameta: '草丈',
      errorName: 'growthHeightErrorMessage'
    },
    {
      keyName: 'ph',
      parameta: 'pH',
      errorName: 'phErrorMessage'
    },
    {
      keyName: 'water_temp',
      parameta: '水温',
      errorName: 'waterTempErrorMessage'
    },
    {
      keyName: 'ground_temp',
      parameta: '地温',
      errorName: 'groundTempErrorMessage'
    }
  ]
  private waterControlNames: any = ['播種潅水', '移植深水', 'ぶんけつ浅水', '中干し', '深水', '間断潅水', '間断潅水', '湛水', '間断潅水', '水切り']
  private waterLevels: any = [5, 10, 5, 0, 10, 10, 10, 6, 5, 0]
  private waterControlDays: any = [7, 14, 25, 7, 8, 20, 16, 20, 16, 0]
  private saveConfirmMessage: string = '<p>コピーまたは実績からの新規作成の場合は<br>すべての内容を確認してください。<br/>この内容で保存してもよろしいでしょうか？</p>'
  private changeConfirmMessage: string = '<p>品種を変更すると、利用しないステージの内容は破棄されます。<br/>よろしいですか？</p>'
  /* 表示非表示 */
  private isEdit: boolean = false
  private showErrorAlert: boolean = false
  private showServerErrorModal: boolean = false
  private showDeleteModal: boolean = false
  private showLoading: boolean = true
  private notSelectVariety: boolean = true
  private showError409Modal: boolean = false
  private showChangeVerifyModal: boolean = false
  private copyFlag: boolean = false
  private isCopy: boolean = false
  private show400ErrorMessage: boolean = false
  private showSaveConfirmModal: boolean = false

  private get route (): any {
    return this.$route.path
  }
  @Watch('route')
  getRoute (route: string) {
    if (this.copyFlag && route === '/master/variety-growth/create') {
      location.reload()
    }
  }

  created () {
    this.getVarietyList()
    this.getAreaList()
    this.constantValue = JSON.parse(Local.getConstantValue()!)

    if (this.$route.path === '/master/variety-growth/create') {
      // コピーがあれば表示、なければデフォルト表示
      const copyData = JSON.parse(Session.getCopyVarietyGrowthData()!)
      if (copyData === undefined || copyData === null) {
        // チェックリストに選択状態項目追加
        for (let i in this.constantValue.checklist_tasks) {
          this.constantValue.checklist_tasks[i].check_status = false
        }

        // stage_stepが7,8,10は初期checkあり
        this.intermittentWaterPeriodFlags = [7, 8, 10]
      } else {
        this.isCopy = true
        this.varietyGrowthData = copyData
        sessionStorage.removeItem('varietyGrowthCopyData')
        this.notSelectVariety = false
        // チェックリストに選択状態項目追加
        for (let i in this.constantValue.checklist_tasks) {
          this.constantValue.checklist_tasks[i].check_status = false
        }
        this.getVarietyDetail(this.varietyGrowthData.variety_growth.variety_id)
        // 品種生育名に（コピー）と表示
        this.varietyGrowthData.variety_growth.variety_growth_name = this.varietyGrowthData.variety_growth.variety_growth_name + '（コピー）'
        // 間断潅水flag設定
        for (let i in this.varietyGrowthData.variety_growth_stages) {
          if (this.varietyGrowthData.variety_growth_stages[i].intermittent_water_period_flag === 1) {
            this.intermittentWaterPeriodFlags.push(this.varietyGrowthData.variety_growth_stages[i].step)
          }
        }
      }
      this.isEdit = false
      this.showLoading = false
    } else {
      this.isEdit = true
      this.getVarietyGrowthDetail()
    }
  }

  private getVarietyName (id: any) {
    for (let i in this.varietyData) {
      if (this.varietyData[i].variety_id === id) {
        return this.varietyData[i].variety_name
      }
    }
  }

  private calculationYeid () {
    // 収量 = ㎡当穂数 × 1穂着粒数 × 千粒重 × 登熟歩合% ÷ 100 ÷ 1000(小数点第２を四捨五入)(入力は小数点第一まで)
    const ear = this.varietyGrowthData.variety_growth.ref_ear
    const grain = this.varietyGrowthData.variety_growth.ref_grain
    const thousandGrainsWeight = this.varietyGrowthData.variety_growth.ref_thousand_grains_weight
    const ripeRate = this.varietyGrowthData.variety_growth.ref_ripe_rate
    const refYield = ear * grain * thousandGrainsWeight * ripeRate / 100 / 1000
    if (ear === null || grain === null || thousandGrainsWeight === null || ripeRate === null) {
      this.varietyGrowthData.variety_growth.ref_yield = null
    } else {
      this.varietyGrowthData.variety_growth.ref_yield = Math.round(refYield * 10) / 10
    }
  }

  private dateToStringYmdHm (date: any) {
    if (date !== undefined && date !== null) {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '/' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '/' + DateClass.toDoubleDigits(updateDate.getDate()) + ' ' + DateClass.toDoubleDigits(updateDate.getHours()) + ':' + DateClass.toDoubleDigits(updateDate.getMinutes())
      return formingDate
    } else {
      return '-'
    }
  }

  // 半角数字、-、.以外入力制限
  private inputCheck (key1: string, key2: string, key3: string) {
    let before
    if (key1 === 'variety_growth') {
      before = String(this.varietyGrowthData[key1][key3])
    } else {
      before = String(this.varietyGrowthData[key1][key2][key3])
    }

    let tmp
    let after: any
    if (before === null) {
      after = null
    } else {
      tmp = before.replace(/[^-.0-9]/g, '')
      tmp = tmp.split('').reverse().join('')
      tmp = tmp.replace(/-(?=.)|\.(?=.*\.)/g, '')
      after = tmp.split('').reverse().join('')
    }

    if (key1 === 'variety_growth') {
      if (isNaN(parseFloat(after))) {
        this.varietyGrowthData[key1][key3] = null
      } else {
        this.varietyGrowthData[key1][key3] = parseFloat(after)
      }
    } else {
      if (isNaN(parseFloat(after))) {
        this.varietyGrowthData[key1][key2][key3] = null
      } else {
        this.varietyGrowthData[key1][key2][key3] = parseFloat(after)
      }
    }
  }

  private beforeVarietyId: number = 0

  // 品種が変更される場合は変更確認モーダルを表示
  private changeVariety () {
    if (this.notSelectVariety) {
      this.beforeVarietyId = this.varietyGrowthData.variety_growth.variety_id
      this.getVarietyDetail(this.varietyGrowthData.variety_growth.variety_id)
    } else {
      this.showChangeVerifyModal = true
    }
  }

  // 変更前の品種を保持
  private beforeChangeVariety () {
    this.beforeVarietyId = this.varietyGrowthData.variety_growth.variety_id
  }

  // 変更前の品種に戻す
  private changeVarietyCancel () {
    this.showChangeVerifyModal = false
    this.varietyGrowthData.variety_growth.variety_id = this.beforeVarietyId
  }

  // 品種情報取得
  private getVarietyList () {
    (async () => {
      const data = {
        word: '',
        order_name: 'created_at',
        sort: false
      }

      const result = await VarietyListApi.getVarietyList(data)

      if (result.isOk()) {
        this.varietyData = result.getPayload().results
        if (result.getPayload().result_count === 0) {
          this.alertText = ''
          this.alertTitle = '品種が未登録です。品種を登録してから圃場を追加してください。'
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  // 地域情報取得
  private getAreaList () {
    (async () => {
      const data = {
        text: '',
        sortName: 'created_at',
        sort: false
      }

      const result = await AreaListApi.getAreaList(data)

      if (result.isOk()) {
        this.areaData = result.getPayload().areas
        if (result.getPayload().total_area === 0) {
          this.alertTitle = '地域が未登録です。地域を登録してから圃場を追加してください。'
          this.alertText = ''
          this.show400ErrorMessage = true
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
    })()
  }

  private getVarietyDetail (id: string) {
    (async () => {
      this.showChangeVerifyModal = false
      this.notSelectVariety = false
      this.resetError()
      const result = await VarietyDetailApi.getVarietyDetail(id)
      if (result.isOk()) {
        this.varietyDetail = result.getPayload().variety_stages
        // ステージ利用flag設定
        for (let i in this.varietyDetail) {
          if (this.varietyDetail[i].is_valid === 1) {
            this.$set(this.isDisable, 'is_valid' + this.varietyDetail[i].step, false)
            this.varietyGrowthData.variety_growth_stages[i].is_valid = 1

            if (!this.isEdit && !this.isCopy) {
              if (this.varietyGrowthData.variety_growth_stages[i].water_control_name === '') {
                this.varietyGrowthData.variety_growth_stages[i].water_control_name = this.waterControlNames[i]
              }
              if (this.varietyGrowthData.variety_growth_stages[i].water_level === 0) {
                this.varietyGrowthData.variety_growth_stages[i].water_level = this.waterLevels[i]
              }
              if (this.varietyGrowthData.variety_growth_stages[i].water_control_days === 0) {
                this.varietyGrowthData.variety_growth_stages[i].water_control_days = this.waterControlDays[i]
              }
              if (this.varietyGrowthData.variety_growth_stages[i].step === 7 ||
                  this.varietyGrowthData.variety_growth_stages[i].step === 8 ||
                  this.varietyGrowthData.variety_growth_stages[i].step === 10) {
                this.varietyGrowthData.variety_growth_stages[i].intermittent_water_period_flag = 1
                if (this.intermittentWaterPeriodFlags.indexOf(this.varietyGrowthData.variety_growth_stages[i].step) === -1) {
                  this.intermittentWaterPeriodFlags.push(this.varietyGrowthData.variety_growth_stages[i].step)
                }
              }
            }
          } else {
            this.$set(this.isDisable, 'is_valid' + this.varietyDetail[i].step, true)
            this.varietyGrowthData.variety_growth_stages[i] = {
              step: this.varietyDetail[i].step,
              integrated_temp: 0,
              spad: 0,
              stem_number: null,
              stem_number_m2: null,
              growth_height: 0,
              ph: 0,
              water_temp: 0,
              ground_temp: 0,
              water_control_name: '',
              water_level: 0,
              water_control_days: 0,
              intermittent_water_period_flag: 0,
              is_valid: 0
            }
            let num = this.intermittentWaterPeriodFlags.indexOf(this.varietyDetail[i].step)
            if (num !== -1) {
              this.intermittentWaterPeriodFlags.splice(num, 1)
            }
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.isCopy = false
      this.showLoading = false
    })()
  }

  private doSave () {
    /* バリデーションチェック */
    if (!this.doValidate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }
    this.showLoading = true

    // 間断潅水flag設定
    for (let i in this.varietyGrowthData.variety_growth_stages) {
      if (this.intermittentWaterPeriodFlags.includes(this.varietyGrowthData.variety_growth_stages[i].step)) {
        this.varietyGrowthData.variety_growth_stages[i].intermittent_water_period_flag = 1
      } else {
        this.varietyGrowthData.variety_growth_stages[i].intermittent_water_period_flag = 0
      }
    }

    const data: any = {
      variety_growth: this.varietyGrowthData.variety_growth,
      variety_growth_stages: []
    }

    // 利用するステージのみをリクエストする
    for (let j in this.varietyGrowthData.variety_growth_stages) {
      if (this.varietyGrowthData.variety_growth_stages[j].is_valid === 1) {
        data.variety_growth_stages.push(this.varietyGrowthData.variety_growth_stages[j])
      }
    }

    if (this.isEdit) {
      // チェックリストに更新があるか判定
      let status = []
      for (let i in this.constantValue.checklist_tasks) {
        if (this.beforeCheckList[i] !== this.constantValue.checklist_tasks[i].check_status) {
          status.push({
            checklist_task_id: this.constantValue.checklist_tasks[i].checklist_task_id,
            check_status: this.constantValue.checklist_tasks[i].check_status
          })
        }
      }
      this.varietyGrowthData.variety_growth.variety_growth_checklist = status

      this.varietyGrowthEdit(data)
    } else {
      this.varietyGrowthData.variety_growth.variety_growth_checklist = []
      // チェックリストに選択状態項目追加
      for (let i in this.constantValue.checklist_tasks) {
        if (this.constantValue.checklist_tasks[i].check_status) {
          this.varietyGrowthData.variety_growth.variety_growth_checklist.push({
            checklist_task_id: this.constantValue.checklist_tasks[i].checklist_task_id
          })
        }
      }

      this.showLoading = false
      this.createData = data
      this.showSaveConfirmModal = true
    }
  }

  private createData: any = {}

  private getVarietyGrowthDetail () {
    (async () => {
      const result = await VarietyGrowthDetailApi.getVarietyGrowthDetail(this.$route.params.variety_growth_id)
      if (result.isOk()) {
        this.varietyGrowthData = result.getPayload()

        let status = []
        // チェックリストに選択状態項目追加
        for (let j in this.varietyGrowthData.variety_growth.variety_growth_checklist) {
          status.push(this.varietyGrowthData.variety_growth.variety_growth_checklist[j].work_check_status)
          for (let i in this.constantValue.checklist_tasks) {
            if (this.varietyGrowthData.variety_growth.variety_growth_checklist[j].checklist_task_id === this.constantValue.checklist_tasks[i].checklist_task_id) {
              this.constantValue.checklist_tasks[i].check_status = this.varietyGrowthData.variety_growth.variety_growth_checklist[j].check_status
              this.constantValue.checklist_tasks[i].check_update_date = this.varietyGrowthData.variety_growth.variety_growth_checklist[j].check_update_date
              this.constantValue.checklist_tasks[i].check_updater = this.varietyGrowthData.variety_growth.variety_growth_checklist[j].check_updater
            }
          }
        }
        // チェックリストに変更があるか確認用に保持
        this.beforeCheckList = status

        this.getVarietyDetail(this.varietyGrowthData.variety_growth.variety_id)

        // 間断潅水flag設定
        for (let i in this.varietyGrowthData.variety_growth_stages) {
          if (this.varietyGrowthData.variety_growth_stages[i].intermittent_water_period_flag === 1) {
            this.intermittentWaterPeriodFlags.push(this.varietyGrowthData.variety_growth_stages[i].step)
          }
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertText = errorData.alertText
          this.alertTitle = errorData.alertTitle
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showLoading = false
    })()
  }

  private async varietyGrowthCreate () {
    this.showLoading = true
    const result = await VarietyGrowthCreateApi.doVarietyGrowthCreate(this.createData)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種生育登録が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety-growth').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'POST', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private async varietyGrowthEdit (data: any) {
    const result = await VarietyGrowthEditApi.doVarietyGrowthEdit(this.$route.params.variety_growth_id, data)

    if (result.isOk()) {
      this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種生育編集が完了しました。' })
      this.$store.commit('alertState/setAlertFlag', true)
      this.$router.push('/master/variety-growth').catch(e => {})
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
    this.showLoading = false
  }

  private countDecimalPoint (val: number) {
    return String(val).split('.')
  }

  private doValidate () {
    this.resetError()
    const varietyNameFlag = Validator.validateInputVarietyName('varietyNameErrorMessage', this.varietyGrowthData.variety_growth.variety_id)
    const varietyGrowthNameFlag = Validator.validateInputVarietyGrowthName('varietyGrowthNameErrorMessage', this.varietyGrowthData.variety_growth.variety_growth_name)
    const harvestCorrectionMinusFlag = Validator.validateInputHarvestCorrectionMinus('harvestCorrectionMinusErrorMessage', this.varietyGrowthData.variety_growth.harvest_correction_minus)
    const harvestCorrectionPlusFlag = Validator.validateInputHarvestCorrectionPlus('harvestCorrectionPlusErrorMessage', this.varietyGrowthData.variety_growth.harvest_correction_plus)
    const areaNameFlag = Validator.validateInputAreaName('areaNameErrorMessage', this.varietyGrowthData.variety_growth.area_id)
    const yieldFlag = Validator.validateInputYield('refYieldErrorMessage', this.varietyGrowthData.variety_growth.ref_yield)
    if (yieldFlag) {
      this.$set(this.isError, 'ref_yield', false)
    } else {
      this.$set(this.isError, 'ref_yield', true)
    }
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    let isError = true
    if (this.varietyGrowthData.variety_growth.ref_ear !== null) {
      const decimalPointLength = this.countDecimalPoint(this.varietyGrowthData.variety_growth.ref_ear)
      if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, 'refEarErrorMessage', '当穂数は小数点第1位までの範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_ear', true)
      } else if (this.varietyGrowthData.variety_growth.ref_ear < 0 || this.varietyGrowthData.variety_growth.ref_ear > 10000) {
        this.$set(this.errorMessages, 'refEarErrorMessage', '㎡当穂数は0以上10,000以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_ear', true)
      } else {
        this.$set(this.isError, 'ref_ear', false)
      }
    } else {
      this.$set(this.isError, 'ref_ear', false)
    }

    if (this.varietyGrowthData.variety_growth.ref_grain !== null) {
      const decimalPointLength = this.countDecimalPoint(this.varietyGrowthData.variety_growth.ref_grain)
      if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, 'refGrainErrorMessage', '1穂着粒数は小数点第1位までの範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_grain', true)
      } else if (this.varietyGrowthData.variety_growth.ref_grain < 0 || this.varietyGrowthData.variety_growth.ref_grain > 1000) {
        this.$set(this.errorMessages, 'refGrainErrorMessage', '1穂着粒数は0以上1,000以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_grain', true)
      } else {
        this.$set(this.isError, 'ref_grain', false)
      }
    } else {
      this.$set(this.isError, 'ref_grain', false)
    }

    if (this.varietyGrowthData.variety_growth.ref_thousand_grains_weight !== null) {
      const decimalPointLength = this.countDecimalPoint(this.varietyGrowthData.variety_growth.ref_thousand_grains_weight)
      if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, 'refThousandGrainsWeightErrorMessage', '千粒重は小数点第1位までの範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_thousand_grains_weight', true)
      } else if (this.varietyGrowthData.variety_growth.ref_thousand_grains_weight < 0 || this.varietyGrowthData.variety_growth.ref_thousand_grains_weight > 1000) {
        this.$set(this.errorMessages, 'refThousandGrainsWeightErrorMessage', '千粒重は0以上1,000以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_thousand_grains_weight', true)
      } else {
        this.$set(this.isError, 'ref_thousand_grains_weight', false)
      }
    } else {
      this.$set(this.isError, 'ref_thousand_grains_weight', false)
    }

    if (this.varietyGrowthData.variety_growth.ref_ripe_rate !== null) {
      const decimalPointLength = this.countDecimalPoint(this.varietyGrowthData.variety_growth.ref_ripe_rate)
      if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
        this.$set(this.errorMessages, 'refRipeRateErrorMessage', '登熟歩合は小数点第1位までの範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_ripe_rate', true)
      } else if (this.varietyGrowthData.variety_growth.ref_ripe_rate < 0 || this.varietyGrowthData.variety_growth.ref_ripe_rate > 100) {
        this.$set(this.errorMessages, 'refRipeRateErrorMessage', '登熟歩合は0以上100以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'ref_ripe_rate', true)
      } else {
        this.$set(this.isError, 'ref_ripe_rate', false)
      }
    } else {
      this.$set(this.isError, 'ref_ripe_rate', false)
    }

    // 品種を選択していない場合は目標値のバリデーションを行わない
    if (!varietyNameFlag) {
      return false
    }

    let isValidStage = []

    // 利用するステージの配列を作成
    for (let i in this.varietyGrowthData.variety_growth_stages) {
      if (this.varietyGrowthData.variety_growth_stages[i].is_valid === 1) {
        isValidStage.push(i)
      }
    }

    for (let i in this.varietyGrowthData.variety_growth_stages) {
      const data = this.varietyGrowthData.variety_growth_stages[i]
      // 積算温度バリデーション
      if (data.integrated_temp !== null) {
        if (data.is_valid !== 0) {
          // 前のステージがどれか判定
          let beforeStageKey: any
          for (let j in isValidStage) {
            if (isValidStage[j] === i) {
              beforeStageKey = isValidStage[parseInt(j) - 1]
              if (beforeStageKey === undefined) {
                beforeStageKey = -1
              }
            }
          }

          if (beforeStageKey !== -1 && data.integrated_temp <= this.varietyGrowthData.variety_growth_stages[beforeStageKey].integrated_temp) {
            this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は下位ステージより大きくなるように入力してください。')
            isError = false
            this.$set(this.isError, 'integrated_temp' + i, true)
          } else if (data.integrated_temp < 0 || data.integrated_temp > 4000) {
            this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は0以上4,000以下の範囲で入力してください。')
            isError = false
            this.$set(this.isError, 'integrated_temp' + i, true)
          } else if (!Number.isInteger(data.integrated_temp)) {
            this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は整数で入力してください。')
            isError = false
            this.$set(this.isError, 'integrated_temp' + i, true)
          } else {
            this.$set(this.isError, 'integrated_temp' + i, false)
          }
        }
      } else {
        this.$set(this.errorMessages, 'integratedTempErrorMessage', '積算温度は整数で入力してください。')
        isError = false
        this.$set(this.isError, 'integrated_temp' + i, true)
      }

      // 値が0~200のバリデーション
      for (let j in this.masterKeys) {
        if (data[this.masterKeys[j].keyName] !== null) {
          let maxValue = 200
          if (this.masterKeys[j].keyName === 'stem_number_m2') {
            maxValue = 4000
          }
          let decimalPointLength = String(data[this.masterKeys[j].keyName]).split('.')
          if (data[this.masterKeys[j].keyName] < 0 || data[this.masterKeys[j].keyName] > maxValue) {
            this.$set(this.errorMessages, this.masterKeys[j].errorName, this.masterKeys[j].parameta + 'は0以上' + this.toLocaleString(maxValue) + '以下の範囲で入力してください。')
            isError = false
            this.$set(this.isError, this.masterKeys[j].keyName + i, true)
          } else if (decimalPointLength[1] !== undefined && decimalPointLength[1].length > 1) {
            this.$set(this.errorMessages, this.masterKeys[j].errorName, this.masterKeys[j].parameta + 'は小数点第1位までの範囲で入力してください。')
            isError = false
            this.$set(this.isError, this.masterKeys[j].keyName + i, true)
          } else {
            this.$set(this.isError, this.masterKeys[j].keyName + i, false)
          }
        } else {
          if (this.masterKeys[j].keyName === 'stem_number' || this.masterKeys[j].keyName === 'stem_number_m2') {
            this.$set(this.isError, this.masterKeys[j].keyName + i, false)
          } else {
            this.$set(this.errorMessages, this.masterKeys[j].errorName, this.masterKeys[j].parameta + 'は必ず入力してください。')
            isError = false
            this.$set(this.isError, this.masterKeys[j].keyName + i, true)
          }
        }
      }

      // 水管理名称のバリデーション
      if (data.step === 11 && data.water_control_name === '') {
        this.$set(this.errorMessages, 'waterControlNameErrorMessage', '収穫適期の水管理名称は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'water_control_name' + i, true)
      } else {
        this.$set(this.isError, 'water_control_name' + i, false)
      }

      // 水管理水位のバリデーション
      if (data.water_level === '') {
        this.$set(this.errorMessages, 'waterLevelErrorMessage', '水位は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'water_level' + i, true)
      } else if (data.water_level < 0 || data.water_level > 200) {
        this.$set(this.errorMessages, 'waterLevelErrorMessage', '水位は0以上200以下の範囲で入力してください。')
        isError = false
        this.$set(this.isError, 'water_level' + i, true)
      } else if (!Number.isInteger(data.water_level)) {
        this.$set(this.errorMessages, 'waterLevelErrorMessage', '水位は整数で入力してください。')
        isError = false
        this.$set(this.isError, 'water_level' + i, true)
      } else {
        this.$set(this.isError, 'water_level' + i, false)
      }

      // 水管理日数のバリデーション
      if (data.water_control_days !== null) {
        if (data.water_control_days < 0 || data.water_control_days > 200) {
          this.$set(this.errorMessages, 'waterControlDaysErrorMessage', '日数は0以上200以下の範囲で入力してください。')
          isError = false
          this.$set(this.isError, 'water_control_days' + i, true)
        } else if (!Number.isInteger(data.water_control_days)) {
          this.$set(this.errorMessages, 'waterControlDaysErrorMessage', '日数は整数で入力してください。')
          isError = false
          this.$set(this.isError, 'water_control_days' + i, true)
        } else {
          this.$set(this.isError, 'water_control_days' + i, false)
        }
      } else {
        this.$set(this.errorMessages, 'waterControlDaysErrorMessage', '水管理日数は必ず入力してください。')
        isError = false
        this.$set(this.isError, 'water_control_days' + i, true)
      }
    }

    return varietyNameFlag && varietyGrowthNameFlag && harvestCorrectionMinusFlag && harvestCorrectionPlusFlag && areaNameFlag && yieldFlag && isError
  }

  /* カンマ区切りにする */
  private toLocaleString (num: number) {
    return String(num).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
  }

  private resetError () {
    for (let i in this.errorMessages) {
      this.errorMessages[i] = ''
    }
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    for (let i in this.varietyGrowthData.variety_growth_stages) {
      const data = this.varietyGrowthData.variety_growth_stages[i]
      // 積算温度バリデーション
      this.$set(this.isError, 'integrated_temp' + i, false)

      // 値が0~200のバリデーション
      for (let j in this.masterKeys) {
        this.$set(this.isError, this.masterKeys[j].keyName + i, false)
        this.masterKeys[j].flag = true
      }

      // 水管理名称のバリデーション
      this.$set(this.isError, 'water_control_name' + i, false)

      // 水管理日数のバリデーション
      this.$set(this.isError, 'water_control_days' + i, false)
    }
  }

  private doVarietyGrowthDelete () {
    (async () => {
      this.showLoading = true
      const result = await VarietyGrowthDeleteApi.doVarietyGrowthDelete(this.$route.params.variety_growth_id)

      if (result.isOk()) {
        this.$store.commit('alertState/setAlertMessage', { type: 0, text: '品種生育を削除しました。' })
        this.$store.commit('alertState/setAlertFlag', true)
        this.$router.push('/master/variety-growth').catch(e => {})
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'DELETE', 'text')
        if (errorData.status_code === '409') {
          this.showError409Modal = true
        } else {
          this.alertTitle = errorData.alertTitle
          this.alertText = errorData.alertText
          this.show400ErrorMessage = true
          window.scrollTo({ top: 0, behavior: 'auto' })
        }
      }
      this.showDeleteModal = false
      this.showLoading = false
    })()
  }

  private createCopy () {
    Session.setCopyVarietyGrowthData(JSON.stringify(this.varietyGrowthData))
    this.copyFlag = true
    this.$router.push('/master/variety-growth/create').catch(e => {})
  }

  private doCancel () {
    this.$router.push('/master/variety-growth').catch(e => {})
  }
}
